import userLogComponent from './user-log.component';

const userLogModule = angular.module('userLog', [
])
  .component('userLog', userLogComponent)
  .name;

export default userLogModule;
